import "instantsearch.css/themes/algolia.css";
import { FC } from "react";
import { Configure, InstantSearch } from "react-instantsearch";
import { searchClient } from "@/lib/algoliasearch/client";
import { MobileSearch } from "./MobileSearch/MobileSearch";
import { PcSearch } from "./PcSearch/PcSearch";

/**
 * Some search result aren't highlighted because result over 500000 characters
 * refercence link: https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/highlighting-snippeting/js/#performance
 */

export const PostSearch: FC = () => {
  return (
    <InstantSearch searchClient={searchClient} indexName="techblog">
      <Configure hitsPerPage={10} attributesToHighlight={["body", "title", "tags.name"]} />
      <PcSearch />
      <MobileSearch />
    </InstantSearch>
  );
};
